import { systemAdminPayment } from './reducers';
export default systemAdminPayment;
